// Official Zetech University social profiles. Used as fallbacks when the
// site_settings row in the backend has no (or partial) social links saved.
export const DEFAULT_SOCIAL_LINKS = {
  facebook: "https://www.facebook.com/ZetechUniversity",
  twitter: "https://twitter.com/ZetechU",
  instagram: "https://www.instagram.com/zetechuniversity/",
  linkedin: "https://www.linkedin.com/school/zetech-university/",
  youtube: "https://www.youtube.com/@ZetechUniversity",
  tiktok: "https://www.tiktok.com/@zetechuniversity",
};

export const resolveSocialLinks = (siteSettings) => {
  const saved = siteSettings?.social_links || {};
  const resolved = { ...DEFAULT_SOCIAL_LINKS };
  Object.keys(DEFAULT_SOCIAL_LINKS).forEach((key) => {
    const value = (saved[key] || "").trim();
    if (value) resolved[key] = value;
  });
  return resolved;
};
